export const ADJUSTMENTS_SETTINGS_FRAME = '@FRAME/Creator/SettingAdjustments/adjustments_settings';
export const ADJUSTMENTS_SETTINGS_PAGE = '@PAGE/Creator/SettingAdjustments/adjustments_settings';
export const ADJUSTMENTS_SETTINGS_TAB = '@TAB/Creator/SettingAdjustments/adjustments_settings';

export const PG_COMMISSION_RATE = 0.0352;
export const VAT_RATE = 0.1;
export const RESIDENT_TAX_RATE = 0.1;
export const INCOME_TAX_RATE = 0.03;
export const MARPPLE_SHOP_FEE_RATE = 0; /* TODO 23년 6월부터 수수료 적용할듯 */
